/**
 * Enum for Message Modal Types.
 */
export enum MessageModalType {
	error = "error",
	info = "info",
	success = "success",
	warning = "warning"
}
